import { default as MySelect } from 'react-select'
import { default as MySelectAsync } from 'react-select/async'

import { colors } from 'shared/constants/values'

type ReactSelectProps = React.ComponentProps<typeof MySelect> &
  Partial<React.ComponentProps<typeof MySelectAsync>> & {
    async?: boolean,
    isSearchable?:boolean
  }

export const ReactSelect = ({ async = false, isSearchable = false, ...props }: ReactSelectProps) => {
  return (
    <>
      {async ? (
        <MySelectAsync
          {...props}
          isSearchable={isSearchable}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary25: colors.corpLight,
              primary: colors.corp,
            },
          })}
        />
      ) : (
        <MySelect
          {...props}
          isSearchable={isSearchable}
          theme={(theme) => ({
            ...theme,
            colors: {
              ...theme.colors,
              primary25: colors.corpLight,
              primary: colors.corp,
            },
          })}
        />
      )}
    </>
  )
}
